// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3T1F0","rootSuccess":"CompleteLink_rootSuccess__19h9f","rootFailure":"CompleteLink_rootFailure___fvWm","isDisabled":"CompleteLink_isDisabled__J8tzQ"};